import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { MYCLAIMSNOTIFICATIONS_INIT_LOADING, MYCLAIMSNOTIFICATIONS_INIT_SUCCESS, MYCLAIMSNOTIFICATIONS_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

const state = {
  myClaimsNotifications: {
    init: 0,
    menu: {},
    lastUpdated: null,
    scope: null,
    appId: null,
    info: null,
    appIds: [],
    chartInfo: []
  }
}

const getters = {
}

const actions = {
  async initMyClaimsNotifications({ commit, state }, data) {
    commit(MYCLAIMSNOTIFICATIONS_INIT_LOADING)
    const apiUrl = state.permitWidgets.myClaimsNotifications
    if (apiUrl) {
      try {
        let params = {
          scope: data.scope,
          appId: data.appId
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)

        Object.assign(data, {
          menu: menu,
          info: result.data.info,
          appIds: result.data.appIds,
          chartInfo: result.data.chartInfo
        })
        commit(MYCLAIMSNOTIFICATIONS_INIT_SUCCESS, data)
      } catch (error) {
        commit(MYCLAIMSNOTIFICATIONS_INIT_FAIL)
      }
    } else {
      commit(MYCLAIMSNOTIFICATIONS_INIT_FAIL)
    }
  }
}

const mutations = {
  [MYCLAIMSNOTIFICATIONS_INIT_LOADING](state) {
    state.myClaimsNotifications.init = 0
  },
  [MYCLAIMSNOTIFICATIONS_INIT_SUCCESS](state, data) {
    const { myClaimsNotifications } = state
    myClaimsNotifications.menu = data.menu
    myClaimsNotifications.init = 1
    myClaimsNotifications.lastUpdated = new Date()
    myClaimsNotifications.scope = data.scope
    myClaimsNotifications.appId = data.appId
    myClaimsNotifications.info = data.info
    myClaimsNotifications.appIds = data.appIds
    Vue.set(myClaimsNotifications, 'chartInfo', data.chartInfo)
  },
  [MYCLAIMSNOTIFICATIONS_INIT_FAIL](state) {
    state.myClaimsNotifications.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
